import React from 'react';
import { containsHTML } from '../../utilities/utils';
import { TextWithHTMLProps } from '../../utilities/types/common';

const TextWithHTML: React.FC<TextWithHTMLProps> = ({ content }) => {
    if (containsHTML(content)) {
        return <div dangerouslySetInnerHTML={{ __html: content }} />;
    }
    return <div>{content}</div>;
};

export default TextWithHTML;